import { Response } from '@/types/v2'
import axios from 'axios'

const api_url = process.env.NEXT_PUBLIC_API_URL

type Credentials = {
  email: string
  password: string
}

type ResetPasswordRequest = {
  token: any
  password: string
  confirm_password: string
}

const verify = async (token: string): Promise<any> => {
  let config = {}
  if (token) {
    config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  }

  const { data } = await axios.get(api_url + '/auth/verify/', config)
  return data
}

const verifyResetToken = async (token: string | string[]): Promise<any> => {
  const tokenjson = {
    token: token,
  }
  const { data } = await axios.post(api_url + '/auth/verify-reset-token/', tokenjson)
  return data
}

const verifySetToken = async (token: string | string[]): Promise<any> => {
  const tokenjson = {
    token: token,
  }
  const { data } = await axios.post(api_url + '/auth/verify-set-token/', tokenjson)
  return data
}

const login = async (credentials: Credentials): Promise<any> => {
  const { data } = await axios.post(api_url + '/auth/login/', credentials)
  return data
}

const logout = async (): Promise<any> => {
  const { data } = await axios.delete(api_url + '/auth/logout/')
  return data
}

const userSession = (loggedUserJSON: string): any => {
  //// console.warn(loggedUserJSON)
  if (loggedUserJSON) {
    return JSON.parse(loggedUserJSON)
  } else {
    return null
  }
}

const forgotPassword = async (email: string): Promise<string> => {
  const { data: axiosData } = await axios.post<Response<string>>(api_url + '/auth/forgot/', { email })
  return axiosData.message
}

const resetPassword = async (request: ResetPasswordRequest): Promise<any> => {
  const { data } = await axios.post(api_url + '/auth/reset/', request)
  return data
}

const setPassword = async (request: ResetPasswordRequest): Promise<any> => {
  const { data } = await axios.post(api_url + '/auth/set-password/', request)
  return data
}

const activateEmail = async (token: string | string[]): Promise<any> => {
  const tokenjson = {
    token: token,
  }
  const { data } = await axios.post(api_url + '/auth/activate-email/', tokenjson)
  return data
}

export default {
  login,
  logout,
  verify,
  userSession,
  forgotPassword,
  resetPassword,
  verifyResetToken,
  verifySetToken,
  setPassword,
  activateEmail,
}
